import { Ext, LegalPage } from "@/components/LegalPage";
import { Link } from "@/lib/router-compat";
import { trackEmailClick, trackPhoneClick } from "@/lib/analytics";

const cookies = [
  ["clicksdmp-consent, clicksdmp-consent-legacy", "Clicks DMP", "speichert Ihre Entscheidung im Cookie-Hinweis", "12 Monate", "notwendig"],
  ["__cf_bm", "Cloudflare", "Schutz vor automatisierten Zugriffen", "ca. 30 Minuten", "notwendig"],
  ["__dpl", "Lovable", "technische Zuordnung zur ausgelieferten Version der Website", "24 Stunden", "notwendig"],
  ["session-id", "Lovable", "Sitzungskennung für die Besucherstatistik des Hosting-Anbieters (Abschnitt 3.4)", "30 Minuten", "Statistik"],
  ["_ga", "Google", "unterscheidet Besucher für Google Analytics", "2 Jahre", "Statistik, nur mit Einwilligung"],
  ["_ga_54KS6GQ1BY", "Google", "hält den Sitzungsstatus für Google Analytics", "2 Jahre", "Statistik, nur mit Einwilligung"],
];

const Datenschutz = () => (
  <LegalPage title="Datenschutzerklärung" path="/datenschutz" subtitle="Stand: September 2026">
    <h2>1. Verantwortlicher</h2>
    <p>Verantwortlich für die Verarbeitung personenbezogener Daten auf dieser Website ist:</p>
    <address>
      <p>
        Ashraf AlSalaita
        <br />
        Clicks DMP – Design &amp; Media Production
        <br />
        Karl-Traub-Straße 15
        <br />
        68199 Mannheim
        <br />
        Telefon:{" "}
        <a href="tel:+4917670027200" onClick={() => trackPhoneClick()}>
          +49 176 700 27 200
        </a>
        <br />
        E-Mail:{" "}
        <a href="mailto:info@clicksdmp.com" onClick={() => trackEmailClick()}>
          info@clicksdmp.com
        </a>
      </p>
    </address>
    <p>
      Ein Datenschutzbeauftragter ist für unser Unternehmen gesetzlich nicht erforderlich. Bei Fragen
      zum Datenschutz erreichen Sie uns direkt über die genannten Kontaktdaten.
    </p>

    <h2>2. Das Wichtigste in Kürze</h2>
    <ul>
      <li>
        Sie können unsere Website besuchen, ohne persönliche Angaben zu machen. Beim Aufruf werden nur
        die technisch notwendigen Daten verarbeitet, die jeder Webserver benötigt, um Seiten
        auszuliefern und den Betrieb abzusichern.
      </li>
      <li>
        Google Analytics nutzen wir nur, wenn Sie im Cookie-Hinweis auf „Akzeptieren“ klicken. Ihre
        Wahl können Sie jederzeit über den Link „Cookie-Einstellungen“ im Fußbereich der Website ändern.
        Eine einfache Besucherstatistik unseres Hosting-Anbieters läuft ohne Google (Abschnitt 3.4).
      </li>
      <li>
        Wenn Sie ein Beratungsgespräch anfragen, uns eine E-Mail schreiben, anrufen oder über WhatsApp
        schreiben, verwenden wir Ihre Angaben nur, um Ihre Anfrage zu beantworten und das Gespräch
        vorzubereiten.
      </li>
      <li>Wir verkaufen keine Daten, betreiben kein Profiling und treffen keine automatisierten Entscheidungen.</li>
    </ul>

    <h2>3. Hosting und technischer Betrieb</h2>

    <h3>3.1 Hosting (Lovable)</h3>
    <p>
      Vertragspartner für das Hosting dieser Website ist Lovable Labs Sweden AB, Stockholm, Schweden.
      Ausgeliefert werden die Seiten über das weltweite Netzwerk von Cloudflare (Abschnitt 3.2). Beim
      Aufruf einer Seite verarbeitet der Hosting-Anbieter in unserem Auftrag technisch notwendige
      Daten: die IP-Adresse Ihres Geräts, Datum und Uhrzeit des Zugriffs, die aufgerufene Seite, die
      übertragene Datenmenge, Browsertyp und -version, Betriebssystem und die zuvor besuchte Seite
      (Referrer). Diese Daten werden in Server-Protokollen gespeichert, um die Website auszuliefern,
      Störungen zu erkennen und Angriffe abzuwehren. Sie werden nicht mit anderen Daten zusammengeführt
      und nur so lange gespeichert, wie es für diese Zwecke erforderlich ist.
    </p>
    <p>
      Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an einem sicheren und
      stabilen Betrieb der Website). Mit Lovable besteht ein Vertrag zur Auftragsverarbeitung nach
      Art. 28 DSGVO.
    </p>

    <h3>3.2 Auslieferung und Schutz (Cloudflare)</h3>
    <p>
      Die Website wird über das Netzwerk von Cloudflare, Inc., 101 Townsend Street, San Francisco, CA
      94107, USA, ausgeliefert. Cloudflare beschleunigt die Auslieferung und schützt die Website vor
      Angriffen. Dabei werden die in Abschnitt 3.1 genannten Verbindungsdaten verarbeitet, auch auf
      Servern außerhalb der EU. Zur Erkennung automatisierter Zugriffe setzt Cloudflare das technisch
      notwendige Cookie „__cf_bm“ mit einer Laufzeit von etwa 30 Minuten. Cloudflare ist nach dem EU-US
      Data Privacy Framework zertifiziert; ergänzend gelten die Standardvertragsklauseln der
      EU-Kommission.
    </p>
    <p>Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO; für das Cookie § 25 Abs. 2 Nr. 2 TDDDG.</p>

    <h3>3.3 Datenbank, Dateien und Formulare (Lovable Cloud)</h3>
    <p>
      Die Inhalte der Website (Projekte, Bilder, Videos, Blogbeiträge) und die Daten aus dem
      Anfrageformular werden in der Cloud-Infrastruktur von Lovable gespeichert. Speicherort ist ein
      Rechenzentrum in Zürich, Schweiz. Unterauftragsverarbeiter sind Supabase Inc., USA (Datenbank-
      und Speicherplattform), und Amazon Web Services (Rechenzentrum). Für die Schweiz besteht ein
      Angemessenheitsbeschluss der Europäischen Kommission; für einen möglichen Zugriff aus den USA
      gelten das EU-US Data Privacy Framework und die Standardvertragsklauseln der EU-Kommission. Beim
      Laden von Bildern und Videos wird Ihre IP-Adresse an diese Infrastruktur übermittelt.
    </p>
    <p>Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO.</p>

    <h3>3.4 Besucherstatistik des Hosting-Anbieters</h3>
    <p>
      Unser Hosting-Anbieter Lovable stellt uns eine einfache Besucherstatistik bereit: Anzahl der
      Besuche und Seitenaufrufe, aufgerufene Seiten, Herkunftsseite, Sprache, Gerätetyp, Browser und
      Land. Dafür lädt die Website ein kleines Skript des Hosting-Anbieters. Es übermittelt beim Aufruf
      einer Seite die aufgerufene Adresse, die Herkunftsseite (Referrer), die Browsersprache, den
      Browsertyp (User-Agent), das aus der Zeitzoneneinstellung Ihres Geräts abgeleitete Land und eine
      zufällige Sitzungskennung an eine Adresse unserer eigenen Domain, von der aus unser
      Hosting-Anbieter die Daten verarbeitet. Die Sitzungskennung wird im Cookie „session-id“
      gespeichert (Laufzeit 30 Minuten), damit die Seitenaufrufe eines Besuchs zusammengefasst werden
      können. Es werden keine Profile über mehrere Besuche hinweg gebildet, und wir können einzelne
      Personen nicht erkennen.
    </p>
    <p>
      Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse, die Nutzung unserer Website
      in Grundzügen zu verstehen). Sie können diese Statistik verhindern, indem Sie Cookies für
      clicksdmp.com in Ihrem Browser blockieren; die Website bleibt dann voll nutzbar.
    </p>

    <h3>3.5 Schriften</h3>
    <p>
      Die Schriften dieser Website sind lokal auf unserem Server gespeichert. Beim Seitenaufruf wird
      keine Verbindung zu Servern von Google oder anderen Schriftanbietern aufgebaut.
    </p>

    <h2>4. Cookies und Ihre Einwilligung</h2>
    <p>Cookies sind kleine Textdateien, die Ihr Browser speichert. Diese Website verwendet folgende Cookies:</p>
    <div className="table-wrap">
      <table>
        <thead>
          <tr>
            <th>Cookie</th>
            <th>Anbieter</th>
            <th>Zweck</th>
            <th>Laufzeit</th>
            <th>Kategorie</th>
          </tr>
        </thead>
        <tbody>
          {cookies.map((row) => (
            <tr key={row[0]}>
              {row.map((cell, i) => (
                <td key={i}>{cell}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
    <p>
      Beim ersten Besuch erscheint auf jeder Seite ein Cookie-Hinweis mit den gleichwertigen
      Schaltflächen „Akzeptieren“ und „Ablehnen“. Google Tag Manager und Google Analytics werden erst
      geladen, wenn Sie „Akzeptieren“ wählen. Wählen Sie „Ablehnen“, werden keine Statistik-Cookies
      von Google gesetzt und keine Daten an Google übermittelt. Ihre Entscheidung speichern wir zwölf
      Monate lang im Cookie „clicksdmp-consent“. Sie können sie jederzeit über den Link
      „Cookie-Einstellungen“ im Fußbereich ändern oder widerrufen; der Widerruf wirkt für die Zukunft.
      Notwendige Cookies können Sie nur in Ihrem Browser unterbinden; die Website funktioniert dann
      möglicherweise eingeschränkt.
    </p>
    <p>
      Rechtsgrundlage: Art. 6 Abs. 1 lit. a DSGVO und § 25 Abs. 1 TDDDG (Einwilligung) für
      Statistik-Cookies von Google; § 25 Abs. 2 Nr. 2 TDDDG und Art. 6 Abs. 1 lit. f DSGVO für
      notwendige Cookies.
    </p>

    <h2>5. Google Tag Manager und Google Analytics 4</h2>
    <p>
      Nur mit Ihrer Einwilligung nutzen wir den Google Tag Manager und Google Analytics 4. Anbieter ist
      Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irland.
    </p>
    <p>
      <strong>Google Tag Manager</strong> lädt und verwaltet die Analytics-Skripte. Er speichert selbst
      keine Cookies; beim Laden wird Ihre IP-Adresse an Google übermittelt.
    </p>
    <p>
      <strong>Google Analytics 4</strong> erfasst, welche Seiten Sie aufrufen, wie lange Sie bleiben,
      von welcher Seite Sie kommen, welches Gerät und welchen Browser Sie nutzen und aus welcher Region
      Sie ungefähr zugreifen. Zusätzlich messen wir Klicks auf Telefonnummer, E-Mail-Adresse und
      WhatsApp-Schaltflächen sowie das Absenden des Anfrageformulars; die Inhalte des Formulars werden
      dabei nicht übertragen. Google Analytics 4 speichert keine vollständigen IP-Adressen: Die
      IP-Adresse wird auf Servern in der EU gekürzt, bevor Daten an Google-Server, auch in den USA,
      weitergegeben werden. Wir haben den Google Consent Mode v2 eingerichtet und laden die
      Google-Skripte erst nach Ihrer Einwilligung; ohne Einwilligung werden keine Daten an Google
      gesendet.
    </p>
    <p>
      Google LLC ist nach dem EU-US Data Privacy Framework zertifiziert; ergänzend gelten die
      Standardvertragsklauseln der EU-Kommission. Die Daten werden auf Grundlage der Google
      Ads-Datenverarbeitungsbedingungen in unserem Auftrag verarbeitet.
    </p>
    <p>
      Speicherdauer: Ereignisdaten auf Nutzer- und Ereignisebene bis zu 14 Monate; danach stehen nur
      noch zusammengefasste Berichte zur Verfügung.
    </p>
    <p>Rechtsgrundlage: Art. 6 Abs. 1 lit. a DSGVO und § 25 Abs. 1 TDDDG (Einwilligung).</p>
    <p>
      Widerruf: über „Cookie-Einstellungen“ im Fußbereich oder mit dem Browser-Add-on zur Deaktivierung
      von Google Analytics (<Ext href="https://tools.google.com/dlpage/gaoptout" />).
    </p>
    <p>
      Weitere Informationen: Datenschutzerklärung von Google (
      <Ext href="https://policies.google.com/privacy" />) und Hinweise zu Google Analytics (
      <Ext href="https://support.google.com/analytics/answer/6004245" />).
    </p>

    <h2>6. Kontakt per E-Mail, Telefon und WhatsApp</h2>
    <p>
      <strong>E-Mail und Telefon.</strong> Wenn Sie uns eine E-Mail schreiben oder anrufen, verarbeiten
      wir Ihre Kontaktdaten und den Inhalt Ihrer Nachricht, um Ihre Anfrage zu beantworten. Unser
      E-Mail-Postfach wird von GoDaddy.com, LLC, Tempe, Arizona, USA, betrieben; die Übermittlung ist
      durch die Standardvertragsklauseln der EU-Kommission abgesichert. Rechtsgrundlage ist Art. 6
      Abs. 1 lit. b DSGVO, wenn es um einen Auftrag oder dessen Anbahnung geht, sonst Art. 6 Abs. 1
      lit. f DSGVO (berechtigtes Interesse an der Beantwortung Ihrer Anfrage). Wir löschen die Daten,
      sobald Ihre Anfrage erledigt ist und keine gesetzliche Aufbewahrungspflicht besteht.
      Geschäftsbriefe und Rechnungsunterlagen müssen wir nach Handels- und Steuerrecht sechs
      beziehungsweise acht Jahre aufbewahren.
    </p>
    <p>
      <strong>WhatsApp.</strong> Über die Schaltfläche „WhatsApp Chat“ können Sie uns eine Nachricht an
      unsere geschäftliche Nummer senden. Die Schaltfläche ist ein einfacher Link: Erst wenn Sie sie
      anklicken, öffnet sich WhatsApp, und Daten werden an WhatsApp Ireland Limited, 4 Grand Canal
      Square, Grand Canal Harbour, Dublin 2, Irland (Teil der Meta-Gruppe) übermittelt. WhatsApp
      verarbeitet Ihre Telefonnummer, Ihren Profilnamen, Ihre Nachricht (Ende-zu-Ende verschlüsselt)
      und Verbindungsdaten, auch auf Servern in den USA. Meta Platforms, Inc. ist nach dem EU-US Data
      Privacy Framework zertifiziert. Nutzen Sie die WhatsApp-App, kann WhatsApp außerdem die Kontakte
      aus Ihrem Adressbuch verarbeiten; darauf haben wir keinen Einfluss. Wir nutzen WhatsApp Business
      ausschließlich, um Ihre Nachricht zu beantworten; die Inhalte behandeln wir wie eine
      E-Mail-Anfrage und löschen den Chat, sobald Ihre Anfrage erledigt ist und keine
      Aufbewahrungspflicht besteht. Wenn Sie WhatsApp nicht nutzen möchten, erreichen Sie uns jederzeit
      per E-Mail oder Telefon.
    </p>
    <p>
      Rechtsgrundlage: Art. 6 Abs. 1 lit. b oder lit. f DSGVO. Datenschutzhinweise von WhatsApp:{" "}
      <Ext href="https://www.whatsapp.com/legal/privacy-policy-eea" />
    </p>

    <h2>7. Anfrageformular „Beratungsgespräch buchen“</h2>
    <p>
      Über das Formular können Sie ein kostenloses Beratungsgespräch anfragen. Wir erheben dabei:
      Wunschdatum und Uhrzeit, Name, Telefonnummer, Firmenname, E-Mail-Adresse, Geschäftsadresse,
      Branche, Art der gewünschten Arbeit und optional eine Nachricht. Pflichtfelder sind mit *
      gekennzeichnet. Wir nutzen diese Angaben, um Ihre Anfrage zu prüfen, das Gespräch vorzubereiten
      und den Termin mit Ihnen zu bestätigen.
    </p>
    <p>Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO (Maßnahmen vor Vertragsschluss auf Ihre Anfrage).</p>
    <p>
      <strong>Schutz vor Missbrauch.</strong> Das Formular enthält ein für Menschen unsichtbares Feld,
      das automatisierte Eingaben erkennt. Zusätzlich speichern wir beim Absenden die IP-Adresse Ihres
      Geräts, um die Zahl der Anfragen pro Stunde zu begrenzen. Die IP-Adresse wird nach 30 Tagen
      automatisch gelöscht. Einen externen Captcha-Dienst setzen wir nicht ein.
    </p>
    <p>Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse am Schutz vor Spam und Missbrauch).</p>
    <p>
      <strong>Verarbeitung und Speicherdauer.</strong> Ihre Anfrage wird in unserem geschützten
      Verwaltungsbereich gespeichert (Abschnitt 3.3). Anfragen werden zwölf Monate nach Eingang
      automatisch gelöscht. Kommt ein Auftrag zustande, bewahren wir die für den Auftrag nötigen Daten
      nach den Regeln in Abschnitt 6 auf.
    </p>

    <h2>8. Unsere Social-Media-Profile</h2>
    <p>
      Im Fußbereich verlinken wir unsere Profile auf Instagram, Facebook und TikTok. Das sind einfache
      Links ohne eingebettete Plugins; beim Besuch unserer Website werden keine Daten an diese
      Plattformen übertragen. Erst wenn Sie einen Link anklicken, verlassen Sie unsere Website, und es
      gelten die Datenschutzbestimmungen des jeweiligen Anbieters: Meta Platforms Ireland Limited,
      Dublin, für Instagram und Facebook (<Ext href="https://privacycenter.instagram.com/policy" /> und{" "}
      <Ext href="https://www.facebook.com/privacy/policy" />) sowie TikTok Technology Limited, Dublin,
      für TikTok (<Ext href="https://www.tiktok.com/legal/privacy-policy-eea" />). Für die Statistiken,
      die Meta uns zu unseren Profilen bereitstellt („Insights“), sind Meta und wir gemeinsam
      verantwortlich; die Vereinbarung dazu finden Sie unter{" "}
      <Ext href="https://www.facebook.com/legal/terms/page_controller_addendum" />. Entsprechendes gilt
      für die Profilstatistiken von TikTok nach der Vereinbarung von TikTok über die gemeinsame
      Verantwortlichkeit.
    </p>

    <h2>9. Ihre Rechte</h2>
    <p>Sie haben gegenüber uns folgende Rechte in Bezug auf Ihre personenbezogenen Daten:</p>
    <ul>
      <li>
        <strong>Auskunft</strong> (Art. 15 DSGVO): Sie können erfahren, welche Daten wir über Sie
        verarbeiten.
      </li>
      <li>
        <strong>Berichtigung</strong> (Art. 16 DSGVO): Unrichtige oder unvollständige Daten berichtigen
        wir.
      </li>
      <li>
        <strong>Löschung</strong> (Art. 17 DSGVO): Sie können die Löschung Ihrer Daten verlangen, soweit
        keine Aufbewahrungspflicht entgegensteht.
      </li>
      <li>
        <strong>Einschränkung der Verarbeitung</strong> (Art. 18 DSGVO).
      </li>
      <li>
        <strong>Datenübertragbarkeit</strong> (Art. 20 DSGVO): Daten, die Sie uns gegeben haben,
        erhalten Sie auf Wunsch in einem gängigen, maschinenlesbaren Format.
      </li>
      <li>
        <strong>Widerspruch</strong> (Art. 21 DSGVO): Sie können einer Verarbeitung, die wir auf ein
        berechtigtes Interesse stützen, aus Gründen widersprechen, die sich aus Ihrer besonderen
        Situation ergeben. Wir verarbeiten die Daten dann nicht mehr, es sei denn, wir können zwingende
        schutzwürdige Gründe nachweisen, die Ihre Interessen überwiegen.
      </li>
      <li>
        <strong>Widerruf einer Einwilligung</strong> (Art. 7 Abs. 3 DSGVO): Eine erteilte Einwilligung
        können Sie jederzeit mit Wirkung für die Zukunft widerrufen, für Cookies über
        „Cookie-Einstellungen“ im Fußbereich.
      </li>
    </ul>
    <p>
      Zur Ausübung Ihrer Rechte genügt eine formlose Nachricht an{" "}
      <a href="mailto:info@clicksdmp.com" onClick={() => trackEmailClick()}>
        info@clicksdmp.com
      </a>{" "}
      oder an die Anschrift in Abschnitt 1.
    </p>
    <p>
      <strong>Beschwerderecht</strong> (Art. 77 DSGVO): Sie haben das Recht, sich bei einer
      Datenschutz-Aufsichtsbehörde zu beschweren. Für uns zuständig ist:
    </p>
    <address>
      <p>
        Der Landesbeauftragte für den Datenschutz und die Informationsfreiheit Baden-Württemberg
        <br />
        Heilbronner Straße 35
        <br />
        70191 Stuttgart
        <br />
        Telefon: 0711 615541-0
        <br />
        E-Mail: poststelle@lfdi.bwl.de
        <br />
        <Ext href="https://www.baden-wuerttemberg.datenschutz.de" />
      </p>
    </address>

    <h2>10. Datensicherheit</h2>
    <p>
      Alle Verbindungen zu dieser Website sind mit TLS verschlüsselt (erkennbar am Schloss-Symbol im
      Browser). Der Verwaltungsbereich der Website ist nur mit persönlichem Zugang für uns erreichbar.
      Unsere Dienstleister setzen technische und organisatorische Maßnahmen ein, um die Daten gegen
      Verlust, Manipulation und unbefugten Zugriff zu schützen.
    </p>

    <h2>11. Datenübermittlung in andere Länder</h2>
    <p>
      Unser Hosting-Vertragspartner sitzt in Schweden (EU); die Auslieferung erfolgt über das weltweite
      Netzwerk von Cloudflare; Datenbank und Dateien liegen in der Schweiz (Angemessenheitsbeschluss der
      EU-Kommission). Bei Cloudflare, Google, Meta, Supabase, Amazon Web Services und GoDaddy können
      Daten auch in den USA verarbeitet werden. Diese Anbieter sind nach dem EU-US Data Privacy
      Framework zertifiziert oder durch die Standardvertragsklauseln der EU-Kommission gebunden
      (Art. 45 und 46 DSGVO).
    </p>

    <h2>12. Keine automatisierten Entscheidungen, Freiwilligkeit der Angaben</h2>
    <p>
      Wir treffen keine automatisierten Entscheidungen im Einzelfall und betreiben kein Profiling. Die
      Angabe personenbezogener Daten ist freiwillig. Im Anfrageformular sind einige Felder erforderlich,
      weil wir Ihre Anfrage ohne diese Angaben nicht bearbeiten können.
    </p>

    <h2>13. Änderungen dieser Datenschutzerklärung</h2>
    <p>
      Wir passen diese Datenschutzerklärung an, wenn sich unsere Website oder die Rechtslage ändert. Es
      gilt die jeweils auf dieser Seite veröffentlichte Fassung.
    </p>
    <p className="muted">
      Stand: September 2026 · <Link to="/impressum">Impressum</Link> · <Link to="/agb">AGB</Link>
    </p>
  </LegalPage>
);

export default Datenschutz;
